import { render } from "./TotalRefferal.vue?vue&type=template&id=242ef36e&scoped=true"
import script from "./TotalRefferal.vue?vue&type=script&lang=js"
export * from "./TotalRefferal.vue?vue&type=script&lang=js"

import "./TotalRefferal.vue?vue&type=style&index=0&id=242ef36e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242ef36e"]])

export default __exports__